import { sf_dotdangky_dichvu } from "../../models/response/category/sf_dotdangky_dichvu"
export enum DotDangKyDichVuActionTypeIds {
    DOTDANGKYDICHVU_LOAD_START = "DOTDANGKYDICHVU_LOAD_START",
    DOTDANGKYDICHVU_LOAD_SUCCESS = "DOTDANGKYDICHVU_LOAD_SUCCESS",
    DOTDANGKYDICHVU_LOAD_ERROR = "DOTDANGKYDICHVU_LOAD_ERROR",

    DOTDANGKYDICHVU_SHOW_DETAIL_MODAL = "DOTDANGKYDICHVU_SHOW_DETAIL_MODAL",
    DOTDANGKYDICHVU_CLOSE_DETAIL_MODAL = "DOTDANGKYDICHVU_CLOSE_DETAIL_MODAL",
    DOTDANGKYDICHVU_SHOW_DELETE_CONFIRM = "DOTDANGKYDICHVU_SHOW_DELETE_CONFIRM",

    DOTDANGKYDICHVU_SAVE_START = "DOTDANGKYDICHVU_SAVE_START",
    DOTDANGKYDICHVU_SAVE_SUCCESS = "DOTDANGKYDICHVU_SAVE_SUCCESS",
    DOTDANGKYDICHVU_SAVE_ERROR = "DOTDANGKYDICHVU_SAVE_ERROR",

    DOTDANGKYDICHVU_DELETE_START = "DOTDANGKYDICHVU_DELETE_START",
    DOTDANGKYDICHVU_DELETE_SUCCESSS = "DOTDANGKYDICHVU_DELETE_SUCCESSS",
    DOTDANGKYDICHVU_DELETE_ERROR = "DOTDANGKYDICHVU_DELETE_ERROR",

    DOTDANGKYDICHVU_CHANGE_SELECTED_ID = "DOTDANGKYDICHVU_CHANGE_SELECTED_ID"

}

export interface DotDangKyDichVuLoadStartAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_START
}
export interface DotDangKyDichVuLoadSuccessAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_SUCCESS,
    payload: sf_dotdangky_dichvu[]
}
export interface DotDangKyDichVuLoadErrorAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_ERROR,
    payload: string
}

export interface DotDangKyDichVuShowDetailModalAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DETAIL_MODAL,
    payload?: sf_dotdangky_dichvu
}
export interface DotDangKyDichVuCloseDetailModalAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CLOSE_DETAIL_MODAL,
}
export interface DotDangKyDichVuShowDeleteConfirmAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DELETE_CONFIRM,
    payload: boolean
}
export interface DotDangKyDichVuSaveStartAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_START,
    payload: sf_dotdangky_dichvu
}
export interface DotDangKyDichVuSaveSuccessAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_SUCCESS,
    payload: sf_dotdangky_dichvu
}
export interface DotDangKyDichVuSaveErrorAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_ERROR,
    payload: string
}
export interface DotDangKyDichVuDeleteStartAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_START,
    payload: number
}
export interface DotDangKyDichVuDeleteSuccessAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_SUCCESSS,
    payload: number
}
export interface DotDangKyDichVuDeleteErrorAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_ERROR,
    payload: string
}

export interface DotDangKyDichVuChangeSelectedIdsAction {
    type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CHANGE_SELECTED_ID,
    payload: number
}
export type DotDangKyDichVuActionTypes =
    DotDangKyDichVuLoadStartAction | DotDangKyDichVuLoadSuccessAction | DotDangKyDichVuLoadErrorAction |
    DotDangKyDichVuShowDetailModalAction | DotDangKyDichVuShowDeleteConfirmAction |
    DotDangKyDichVuSaveStartAction | DotDangKyDichVuSaveSuccessAction | DotDangKyDichVuSaveErrorAction |
    DotDangKyDichVuDeleteStartAction | DotDangKyDichVuDeleteSuccessAction | DotDangKyDichVuDeleteErrorAction |
    DotDangKyDichVuChangeSelectedIdsAction | DotDangKyDichVuCloseDetailModalAction